
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("7Tg35", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.324b31c5.js.map
